// Backend de autenticação do aplicativo, usuários, Compressores e Despesas.
export const OPERATIONS_API_BASE = 'https://superfrio-backend-platform.vercel.app';
export const AUTH_API_BASE = OPERATIONS_API_BASE;
// Versão da sessão: força novo login após a migração do backend administrativo.
export const APP_SESSION_VERSION = '2';
